<template>
    <div>
        <action-bar>
        </action-bar>
        <main class="content">
            <div>
                <h1>Infobox erstellen</h1>
                <div class="form-group">
                    <label for="input_name">Name</label>
                    <input type="text" class="form-control" v-model="name" id="input_name">
                </div>
                <button class="btn btn-primary" @click="save">Erstellen</button>
            </div>
        </main>
    </div>
</template>
<script>
export default {
  data() {
    return {
      name: ""
    };
  },
  methods: {
    save() {
      let form = new FormData();
      form.append("create_infobox[name]", this.name);
      form.set("edit_text_part[submit]", null);
      axios
        .post("/api/" + store.state.language + "/infobox/create", form)
        .then(({ data }) => {
          this.$router.push({ name: "infobox-list" });
        });
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/pages/admin/infobox/Create.vue